import { WSRoute } from '../../types';
import { ExportType } from '../../../types/export.types';

export type ExportProgressStatus = 'WAITING' | 'STARTED' | 'FINISHED' | 'ERROR';

export interface ExportProgressData {
  status: ExportProgressStatus;
  started_at?: string;
  ended_at?: string;
  file_url?: string;
  task_id?: string;
  error?: string;
  hasFilters?: boolean;
  exportType: ExportType;
  domainId: string;
}

export const EXPORT_TYPE_TO_ROUTE: Record<ExportType, WSRoute> = {
  [ExportType.EXPORT_ANALYSIS]: 'export',
  [ExportType.EXPORT_MATERIALS_DEMANDS]: 'materials-demands-export',
  [ExportType.EXPORT_PO_COMPONENTS]: 'po-components-export',
  [ExportType.EXPORT_STOCK]: 'stock-export',
};

export function buildExportKey(type: ExportType, id: string | number): string {
  return `export_${type}_${id}`;
}
